import styled from "styled-components";

const FundDealsListStyles = styled.div`
  .container {
    padding: 20px;
  }
  .headerSelectMenu {
    width: 100%;
  }
  .headerItems > * {
    display: inline-block;
  }
  .headerItems h3 {
    padding-right: 30px;
  }
  .headerDropdownMenu {
    width: auto;
    min-width: 300px;
    max-width: 500px;
  }
  .headerDropdownMenu > :before {
    border-bottom: 3px solid #55555f;
  }
  .headerDropdownMenu > :after {
    border-bottom: 3px solid #55555f;
  }
  .tileHeader {
    margin-left: 20px;
    text-transform: capitalize;
  }
`;

export default FundDealsListStyles;
